export default __webpack_public_path__ + "static/media/KronaOne-Regular.c16b3db2.ttf";